export const FEATURES_AND_BENEFITS_CONTENT: { [key: string]: { title: string, subTitle?: string, description: string, instructions?: string[] } } = {
    'MADE-CC-features-benefits': {
        title: 'Easy Upkeep HVAC features & benefits',
        subTitle: 'Provide annual HVAC preventive maintenance checks:',
        description: 'one heating and one cooling check (one unit per visit) using a 17-point checklist designed to maintain performance and catch issues early, and more.'
    },
    'Handyman-features-benefits-CA': {
        title: 'Handyman Reimbursement Benefit',
        description: 'Making a new home your own often means tackling small projects. Your plan includes a one-time handyman reimbursement up to $100, so you can take care of those to-dos while keeping more money in your pocket.',
    },
    'Handyman-features-benefits': {
        title: 'Handyman Reimbursement Benefit',
        description: 'Making a new home your own often means tackling small projects. Your plan includes a one-time handyman reimbursement up to $100, so you can take care of those to-dos while keeping more money in your pocket.',
    },
    'Wholesale-club-features-benefits-CA': {
        title: 'Wholesale Club Reimbursement Benefit',
        description: 'Joining a wholesale club can mean big savings for your household. With your plan, you can receive up to $130 back when you sign up for an eligible wholesale club membership.',
    },
    'Wholesale-club-features-benefits': {
        title: 'Wholesale Club Reimbursement Benefit',
        description: 'Joining a wholesale club can mean big savings for your household. With your plan, you can receive up to $130 back when you sign up for an eligible wholesale club membership.',
    },
    'Locksmith-reimbursement-resource': {
        title: 'Locksmith Reimbursement',
        subTitle: 'Choose your own locksmith',
        description: '',
        instructions: [
            'Simply call a local locksmith company in your area.',
            'Pay them for the services.',
            'Send the paid invoice to get your reimbursement.'
        ]
    }
};